export default "__VITE_PUBLIC_ASSET__5658d0f0__"